Ext.define('SA.data.locationsearch.AddressQueryManager', {
    extend: 'SA.data.QueryManager',

    queryCache: {},
    queryList: [],

    address: '',

    abort() {
        this.query = null;
    },

    buildQuery(params) {
        var address = (params || this).address.trim(),
            geographicUnits = (params || this).geographicUnits,
            pageSize = this.pageSize,
            start = (this.page - 1) * pageSize,
            countryId = SA.data.GeographicUnits.countryFor(geographicUnits[0]),
            country = SA.Institution.getCountry(countryId),
            censusRelease = this.censusRelease || country.getLatestCensusRelease(),
            geographicReleases = [country.getLatestGeographicReleaseForCensusRelease(censusRelease)];

        if (!address.match(/^\d.*([ ,]+[^ ,]+){3}/)) {
            return null;
        }

        return {
            type: 'location-search',

            address,
            fields: SA.data.LocationsCache.getQueryFields(),
            geographicReleases,
            geographicUnits,
            limit: pageSize,
            start
        };
    },

    onSuccess(response) {
        var results = this.prepareResponse(response);

        SA.data.LocationsCache.add(results);

        this.onResults.call(this.scope, {
            results: results.map(result => SA.data.LocationsCache.canonicalize(result))
        });
    },

    setCensusRelease(censusRelease) {
        this.censusRelease = censusRelease;
    },

    setParameters(params) {
        this.address = params.address.trim();
        this.geographicUnits = params.geographicUnits;

        this.refresh();
    }
});
